<template>
  <div>
    <div class="detail-title">
      <div class="ps-18b">교육장 안내</div>
    </div>
    <div class="map-selector">
      <div v-for="btn in mapInfo" :key="btn + btn.id" @click="selectMap(btn.id)" :class="['map-btn', {active: selectedMap.id === btn.id}]">
        {{ btn.name }}
      </div>
    </div>
    <div class="map-container">
      <div :id="'map' + selectedMap.id" class="map-section" />
      <div class="detail-subject">{{ selectedMap.name }}</div>
      <div class="detail-wrap">
        <div class="detail-item is-14r">
          <b>주소 : </b>
          <div>{{ selectedMap.address }}</div>
        </div>
        <div class="detail-item is-14r">
          <b>오시는길 : </b>
          <div v-html="selectedMap.direction" />
        </div>
      </div>
    </div>
    <Spinner v-if="isSpinner" />
  </div>
</template>

<script>
import {useSeminarStore} from '~/store/seminar/index.js'
import Spinner from '~/components/common/loading/Spinner.vue'

export default {
  name: 'SeminarTab3',
  components: {Spinner},
  setup() {
    const store = useSeminarStore()
    return {store}
  },
  data() {
    return {
      isSpinner: false,
      mapInfo: [
        {
          id: 0,
          name: '',
          address: '',
          direction: '',
          lat: '',
          lng: ''
        }
      ],
      selectedMap: {
        id: 0,
        name: '',
        address: '',
        direction: '',
        lat: '',
        lng: ''
      },
      map1: null,
      marker1: null
    }
  },
  async mounted() {
    await this.getSeminarLocation()
  },
  methods: {
    async getSeminarLocation() {
      try {
        const {data} = await this.store.getSeminarLocation()
        this.mapInfo = data
        this.selectMap(this.mapInfo[0].id)
        this.initMap()
      } catch (e) {
        console.error(e)
      }
    },
    selectMap(id) {
      this.isSpinner = true
      this.selectedMap = this.mapInfo.find(map => map.id === id)

      // 기존 맵 요소 삭제
      const container = document.getElementById(`map${this.selectedMap.id}`)
      if (container) {
        container.innerHTML = '' // 기존 맵을 지움
      }

      setTimeout(() => {
        this.initMap()
        this.isSpinner = false
      }, 500)
    },
    initMap() {
      if (process.client) {
        window.kakao.maps.load(() => {
          const container1 = document.getElementById(`map${this.selectedMap.id}`)

          if (!container1) return // 컨테이너가 없으면 종료

          const options1 = {
            center: new window.kakao.maps.LatLng(this.selectedMap.lat, this.selectedMap.lng),
            level: 3
          }

          // 기존 지도 객체 초기화
          if (this.map1) {
            this.map1 = null
            this.marker1 = null
          }

          this.map1 = new window.kakao.maps.Map(container1, options1)
          this.marker1 = new window.kakao.maps.Marker({
            position: new window.kakao.maps.LatLng(this.selectedMap.lat, this.selectedMap.lng)
          })
          this.marker1.setMap(this.map1)
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.detail-title {
  margin-bottom: 24px;
}
.map-selector {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  .map-btn {
    color: #fff;
    padding: 12px;
    width: 50%;
    text-align: center;
    border-radius: 8px;
    cursor: pointer;
    background: #afc4f5;

    &.active {
      background: #0058aa;
    }
  }
}
.map-container {
  margin-bottom: 24px;
}
.detail-subject {
  margin-bottom: 24px;
}
.detail-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.map-section {
  height: 400px;
  margin-bottom: 24px;
}
</style>
